import { SVGProps } from 'react';

export const EpisodesIconDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='13'
    height='14'
    viewBox='0 0 13 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#clip0_6963_432371)'>
      <path
        d='M4.41406 9.6981V6.42996C4.41406 6.01964 4.85579 5.76977 5.19568 5.9879L7.59264 7.52585C7.90135 7.72389 7.91345 8.17936 7.61574 8.39428L5.21878 10.1245C4.88069 10.3685 4.41406 10.1212 4.41406 9.6981Z'
        fill='var(--text-and-icon-muted)'
      />
      <path
        d='M2.29199 3.82821C3.26399 2.42645 4.78512 1.4502 6.58431 1.4502C9.54116 1.4502 11.9384 3.90157 11.9384 6.92515C11.9384 8.09463 11.5774 9.18265 10.9649 10.0708C10.8311 10.2647 10.842 10.2755 10.6853 10.4492'
        stroke='var(--text-and-icon-muted)'
        strokeWidth='0.650537'
      />
      <path
        d='M11.2164 8.10429C11.2164 8.71836 11.1163 9.31668 10.9315 9.86776C10.9084 9.94649 10.8776 10.0252 10.8545 10.104C10.8545 10.1197 10.8468 10.1355 10.8391 10.1433C10.7313 10.411 10.6081 10.6709 10.4618 10.9228C9.52255 12.5681 7.76712 13.6782 5.76538 13.6782C2.7551 13.6782 0.314453 11.1825 0.314453 8.10429C0.314453 6.51396 0.961169 5.08111 2.01598 4.06556C2.20078 3.8766 2.40868 3.71125 2.6242 3.55377C2.6396 3.5459 2.655 3.53015 2.6704 3.52228C3.54811 2.89246 4.61824 2.53027 5.76545 2.53027C8.77573 2.53027 11.2164 5.02599 11.2164 8.10429Z'
        stroke='var(--text-and-icon-muted)'
        strokeWidth='0.650537'
      />
      <path
        d='M3.17383 2.98115C4.03622 1.39733 5.6954 0.321289 7.60113 0.321289C10.4091 0.321289 12.6856 2.64917 12.6856 5.5205C12.6856 6.96316 12.113 8.26698 11.1832 9.20748'
        stroke='var(--text-and-icon-muted)'
        strokeWidth='0.650537'
      />
    </g>
    <defs>
      <clipPath id='clip0_6963_432371'>
        <rect width='13' height='14' fill='var(--text-and-icon-muted)' />
      </clipPath>
    </defs>
  </svg>
);

export const EpisodesIconLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='14'
    viewBox='0 0 13 14'
    fill='none'
    {...props}>
    <g clipPath='url(#clip0_6963_434217)'>
      <path
        d='M4.41406 9.69713V6.42898C4.41406 6.01866 4.85579 5.76879 5.19568 5.98693L7.59264 7.52487C7.90135 7.72292 7.91345 8.17839 7.61574 8.39331L5.21878 10.1235C4.88069 10.3675 4.41406 10.1202 4.41406 9.69713Z'
        fill='var(--text-and-icon-invert)'
      />
      <path
        d='M2.29199 3.82919C3.26399 2.42743 4.78512 1.45117 6.58431 1.45117C9.54116 1.45117 11.9384 3.90254 11.9384 6.92612C11.9384 8.09561 11.5774 9.18363 10.9649 10.0717C10.8311 10.2657 10.842 10.2765 10.6853 10.4502'
        stroke='var(--text-and-icon-invert)'
        strokeWidth='0.650537'
      />
      <path
        d='M11.2164 8.10331C11.2164 8.71738 11.1163 9.3157 10.9315 9.86678C10.9084 9.94552 10.8776 10.0243 10.8545 10.103C10.8545 10.1187 10.8468 10.1345 10.8391 10.1424C10.7313 10.4101 10.6081 10.6699 10.4618 10.9218C9.52255 12.5671 7.76712 13.6772 5.76538 13.6772C2.7551 13.6772 0.314453 11.1815 0.314453 8.10331C0.314453 6.51299 0.961169 5.08013 2.01598 4.06459C2.20078 3.87562 2.40868 3.71027 2.6242 3.5528C2.6396 3.54492 2.655 3.52918 2.6704 3.5213C3.54811 2.89149 4.61824 2.5293 5.76545 2.5293C8.77573 2.5293 11.2164 5.02502 11.2164 8.10331Z'
        stroke='var(--text-and-icon-invert)'
        strokeWidth='0.650537'
      />
      <path
        d='M3.17383 2.98213C4.03622 1.39831 5.6954 0.322266 7.60113 0.322266C10.4091 0.322266 12.6856 2.65015 12.6856 5.52148C12.6856 6.96413 12.113 8.26795 11.1832 9.20846'
        stroke='var(--text-and-icon-invert)'
        strokeWidth='0.650537'
      />
    </g>
    <defs>
      <clipPath id='clip0_6963_434217'>
        <rect width='13' height='14' fill='var(--text-and-icon-invert)' />
      </clipPath>
    </defs>
  </svg>
);
